
import './index.css';

import React from 'react';
import { Link } from 'react-router-dom';
import { EditIcon, TrashIcon } from '../../ui/AppIcon';
import TableSortButton from '../../table/TableSortButton';

const RecordList = ({
  slug = '',
  single = '',
  order = null,
  sort = '',
  updateParams,
  DEFAULT_ASC_FIELDS = [],
  data = {},
}) => {



  const canViewRecord = Boolean(slug);
  const canManageContent = Boolean(data.canManageContent);
  const canUpdateContent = data.canUpdateContent ?? canManageContent;
  const canEdit = canViewRecord && canUpdateContent;
  const canDelete = canManageContent;




  return (
    <table className="data-table">
      <thead>
        <tr>

          {(( detail ) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Data.identity( detail.row.value );
            
            return (
              <th>
                {Component.meta.sort ? (
                  <TableSortButton
                    currentOrder={order}
                    currentSort={sort}
                    defaultAscFields={DEFAULT_ASC_FIELDS}
                    field={detail.column.field}
                    onChange={updateParams}
                  >
                    {detail.column.label}
                  </TableSortButton>
                ) : detail.column.label}
              </th>
            );
          })( data.handle )}

          {data.details.map((detail, index) => {

            const Components = require( '../../../elements' ).default;

            const Component = Components.Data.identity( detail.row.value );
            
            return (
              <th key={detail.key || index}>
                {Component.meta.sort ? (
                  <TableSortButton
                    currentOrder={order}
                    currentSort={sort}
                    defaultAscFields={DEFAULT_ASC_FIELDS}
                    field={detail.column.field}
                    onChange={updateParams}
                  >
                    {detail.column.label}
                  </TableSortButton>
                ) : detail.column.label}
              </th>
            );
          })}

          <th>Actions</th>

        </tr>
      </thead>
      <tbody>
        {data.rows.map( ( row ) => (
          <tr key={row.data.id || row.data.slug || row.data.name || JSON.stringify(row.data)}>

            {( ( detail ) => {

              const Components = require( '../../../elements' ).default;

              const Component = Components.Data.identity( detail.row.value );

              return (
                <td>
                  {canViewRecord ? (
                    <Link className="inline-link" to={`/${slug}/${row.data.id}`}>
                      <Component.Output handle={detail.column.field} meta={detail.row.meta} record={row} />
                    </Link>
                  ) : (
                    <Component.Output handle={detail.column.field} meta={detail.row.meta} record={row} />
                  )}
                </td>
              );
            } )( data.handle )}

            {data.details.map( ( detail, index ) => {

              const Components = require( '../../../elements' ).default;

              const Component = Components.Data.identity( detail.row.value );
              
              return (
                <td key={detail.key || index}>
                  <Component.Output handle={detail.column.field} meta={detail.row.meta} record={row} />
                </td>
              );
            })}

            <td className="table-actions">
              {canEdit ? (
                <Link
                  aria-label={`Edit ${single}`}
                  className="table-action-btn"
                  to={`/${slug}/${row.data.id}/edit`}
                >
                  <EditIcon />
                </Link>
              ) : null}
              {canDelete ? (
                <button
                  aria-label={`Delete ${single}`}
                  className="table-action-btn table-action-btn-danger"
                  disabled={data.actions.deletingId === row.data.id}
                  onClick={() => data.actions.handleDelete(row.data.id)}
                  type="button"
                >
                  <TrashIcon />
                </button>
              ) : null}
            </td>

          </tr>
        ))}
        {data.rows.length === 0 ? (
          <tr>
            <td colSpan={data.details.length + 2}>No records found.</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );
};

export default RecordList;